import PropTypes from 'prop-types';

import React from 'react';

class ErrorBar extends React.Component {
  static propTypes = {
    message: PropTypes.any,
  };

  render() {
    return (
      <div className='site-error'>
        <div className='container b' style={{color: '#cc0000', fontSize: '1.5em'}}>
          <i className='fa fa-exclamation-triangle' />
          &nbsp;
          {this.props.message}
        </div>
      </div>
    );
  }
}

export default ErrorBar;
